import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M876.612259,1043.38774 L876.612259,1753.55901 L761.268541,1753.55901 L761.268541,1240.27947 L81.6633525,1920 L0,1838.33665 L679.720532,1158.73146 L166.440985,1158.73146 L166.440985,1043.38774 L876.612259,1043.38774 Z M1838.39432,0 L1919.94233,81.5480088 L1240.33714,761.268541 L1753.61669,761.268541 L1753.61669,876.612259 L1043.44541,876.612259 L1043.44541,166.440985 L1158.78913,166.440985 L1158.78913,679.605188 L1838.39432,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconExitFullScreenLine = /*#__PURE__*/function (_Component) {
  _inherits(IconExitFullScreenLine, _Component);

  var _super = _createSuper(IconExitFullScreenLine);

  function IconExitFullScreenLine() {
    _classCallCheck(this, IconExitFullScreenLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconExitFullScreenLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconExitFullScreen",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconExitFullScreenLine.displayName = "IconExitFullScreenLine";
  return IconExitFullScreenLine;
}(Component);

IconExitFullScreenLine.glyphName = 'exit-full-screen';
IconExitFullScreenLine.variant = 'Line';
IconExitFullScreenLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconExitFullScreenLine;
export { IconExitFullScreenLine };